/* OkeyDice — sons du dé (Web Audio synth). window.OKD_dice.roll() = roulement ; verdict(isYes) = victoire/négation. */
(function(){
  'use strict';
  var actx = null;
  function ctx(){
    if(!actx){ try { actx = new (window.AudioContext || window.webkitAudioContext)(); } catch(e){ return null; } }
    if(actx.state === 'suspended'){ actx.resume(); }
    return actx;
  }
  function clack(ac, t, amp, freq){
    var dur = 0.05, n = Math.floor(ac.sampleRate*dur);
    var buf = ac.createBuffer(1, n, ac.sampleRate);
    var d = buf.getChannelData(0);
    for(var i=0;i<n;i++){ d[i] = (Math.random()*2-1) * (1 - i/n); }
    var src = ac.createBufferSource(); src.buffer = buf;
    var hp = ac.createBiquadFilter(); hp.type='highpass'; hp.frequency.value=500;
    var bp = ac.createBiquadFilter(); bp.type='bandpass'; bp.frequency.value=freq; bp.Q.value=1.2;
    var g = ac.createGain();
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(amp, t+0.003); g.gain.exponentialRampToValueAtTime(0.0001, t+dur);
    src.connect(hp); hp.connect(bp); bp.connect(g); g.connect(ac.destination);
    src.start(t); src.stop(t+dur);
  }
  function tone(ac, freq, t, dur, type, amp){
    var o = ac.createOscillator(); o.type = type||'triangle'; o.frequency.setValueAtTime(freq, t);
    var lp = ac.createBiquadFilter(); lp.type='lowpass'; lp.frequency.value=5200;
    var g = ac.createGain();
    g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(amp, t+0.02); g.gain.exponentialRampToValueAtTime(0.0001, t+dur);
    o.connect(lp); lp.connect(g); g.connect(ac.destination);
    o.start(t); o.stop(t+dur+0.03);
  }
  function roll(){
    var ac = ctx(); if(!ac) return; var t0 = ac.currentTime + 0.01;
    var offsets = [0,0.05,0.11,0.18,0.26,0.35,0.45,0.57,0.71,0.88,1.08,1.32,1.62,1.98,2.3];
    for(var i=0;i<offsets.length;i++){
      var amp = Math.max(0.035, 0.17 - i*0.0105);
      clack(ac, t0 + offsets[i] + (Math.random()*0.018-0.009), amp, 1400 + Math.random()*2400);
    }
  }
  function verdict(isYes){
    var ac = ctx(); if(!ac) return; var t = ac.currentTime + 0.02;
    if(isYes){
      var notes = [523.25, 659.25, 783.99, 1046.50];
      for(var i=0;i<notes.length;i++){ tone(ac, notes[i], t + i*0.085, 0.24, 'triangle', 0.16); }
    } else {
      tone(ac, 329.63, t, 0.16, 'sawtooth', 0.14);
      tone(ac, 246.94, t + 0.14, 0.20, 'sawtooth', 0.14);
      tone(ac, 174.61, t + 0.31, 0.42, 'sawtooth', 0.13);
    }
  }
  window.OKD_dice = { roll: roll, verdict: verdict };
})();
